export function deleteSession() {
  localStorage.removeItem('TD_INTERNAL_SESSION')
}
